<div class=" text-center" style="background-color: #0c5460;width: 130px; border-radius: 40px;margin-bottom: 10px;margin-top: 10px;">
    <app-login-icon ></app-login-icon>
</div>
<mat-accordion *ngIf="menuTree != null">

    <mat-expansion-panel hideToggle *ngFor="let c of menuTree.children">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <img class="cat-icon" src="assets/icons_/{{c.id}}.png"> {{c.name}}
            </mat-panel-title>
            <i class="fa fa-caret-right pull-right"></i>

        </mat-expansion-panel-header>


        <div *ngIf="c.children.length > 0">
            <ul>

                <li class="text-left" *ngFor="let sc of c.children" (click)="goToProductBrowserPage(sc.id)">
                    <a> {{sc.name}}</a>
                </li>
            </ul>
        </div>

    </mat-expansion-panel>
</mat-accordion>

